import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, Tab, Tabs } from '@mui/material';
import { tabsClasses } from '@mui/material/Tabs';

import SettingForm from './form/setting_form';
import ExpirationPromotionsList from './expiration_promotions_list';
import PageHeader from '../../../common/page_header';

const ExpirationPromotionsPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [tab, setTab] = useState(location?.state?.tab || 0);

    const onTabChange = (tabValue) => {
        navigate(location.pathname, {});
        setTab(tabValue);
    }

    const renderView = () => {
        if (tab === 0) {
            return <ExpirationPromotionsList tab={ tab }/>;
        }
        if (tab === 1) {
            return <SettingForm tab={ tab }/>;
        }

        return null;
    };

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>
            <PageHeader
                title="Promocje na krótki termin"
            />

            <Box sx={ { borderBottom: 1, borderColor: 'divider' } }>
                <Tabs
                    value={ tab }
                    onChange={ (_, value) => onTabChange(value) }
                    sx={ {
                        [`& .${ tabsClasses.scrollButtons }`]: {
                            '&.Mui-disabled': { opacity: 0.3 },
                        },
                    } }
                >
                    <Tab label="Promocje"/>
                    <Tab label="Ustawienia"/>
                </Tabs>
            </Box>

            { renderView() }
        </Box>
    );
};

export default ExpirationPromotionsPage;